export const data = {
  genderOptions: [
    { label: 'Feminino', value: 'F' },
    { label: 'Masculino', value: 'M' }
  ]
}
